/**
 * 프로젝트 중립 콘솔 로그 태그. 템플릿 재사용 시 수정 불필요.
 * 디스패치/페이지 부트스트랩 경고에 공통으로 붙인다.
 */
export const LOG_PREFIX = "[app]";
